import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';
import classnames from 'classnames';
import {getUserPaymentsRequest} from 'requests';
import {Loader} from 'components/Loader';
import {ForwardIcon} from 'icons';

import './payment-history.scss';
import {formatStrategyPrice, formatPaymentTime} from 'utils/mixins';

class PaymentHistory extends Component {
  state = {
    payments: [],
  };

  async componentDidMount() {
    this.setState({loading: true});

    try {
      const payments = await getUserPaymentsRequest();
      this.setState({payments, loading: false});
    } catch (err) {
      console.warn('Handled error in Payment History:', err);
    }
  }

  render() {
    const {payments, loading} = this.state;

    if (loading) return <Loader />;
    return (
      <div className="payment-history-page">
        <div
          className={classnames('payments-box', {
            empty: !(payments.length > 0),
          })}
        >
          {payments.length ? (
            payments.map(payment => {
              const {id, price, time, strategyTitle} = payment;
              return (
                <Link key={id} to={{pathname: `/account/payments/${id}`, state: {payment}}} className="payment-link">
                  <div key={id} className="payment">
                    <div className="payment-info">
                      <div className="payment-strategy">{strategyTitle}</div>
                      <div className="payment-time">{formatPaymentTime(time)}</div>
                    </div>
                    <div className="payment-price">
                      <div>{formatStrategyPrice(price)} &#36;</div>
                      <div className="forward-icon">
                        {' '}
                        <ForwardIcon />
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })
          ) : (
            <p className="message no-payments">You don&apos;t have any payments.</p>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(PaymentHistory);
